import { Component, OnInit, ViewChild, TemplateRef, HostBinding, Output, EventEmitter, Input, ChangeDetectorRef, Optional, LOCALE_ID, Inject } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { DatagridComponent } from '@farris/ui-datagrid';
import { ApprovalPivotConfig } from './approval-pivot-config';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ExpressionService, InjectedType, ExprEditMode, VarEntity } from '@gsp-svc/expression';
import { ApprovalPivot } from './approval-pivot';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-approval-pivot',
  templateUrl: './approval-pivot.component.html',
  styleUrls: ['./approval-pivot.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class ApprovalPivotComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;

  @Input()
  set value(data: any) {
    this.config.localePipe = this.localePipe;
    if (data) {
      this.config.enable = data.enable;
      this.config.title = data.title;
      this.config.expand = data.expand;
      if (data.approvalPivots && data.approvalPivots.length > 0) {
        for (const a of data.approvalPivots) {
          const approvalPivot = new ApprovalPivot();
          approvalPivot.type = a.type;
          approvalPivot.title = a.title;
          approvalPivot.description = a.description;
          if (a.condition) {
            if (typeof (a.condition) === 'string') {
              approvalPivot.condition = a.condition;
            } else {
              approvalPivot.condition = a.condition._value;
            }
          }


          this.config.approvalPivots = this.config.approvalPivots.concat([approvalPivot]);
        }
      }
    }
  }

  config = new ApprovalPivotConfig();

  typeList = [
    { value: 'REMIND', text: this.localePipe.transform('component.approvalPivot.remind') }];

  columns = [
    {
      field: 'type', width: 80, title: this.localePipe.transform('component.approvalPivot.type'),
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: this.typeList }
      },
      editor: {
        type: EditorTypes.COMBOLIST,
        options: { valueField: 'value', textField: 'text', data: this.typeList, idField: 'value', panelHeight: 'auto', enableClear: false }
      },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'condition', width: 120, title: this.localePipe.transform('component.approvalPivot.condition'), showTips: true,
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.editConditon(e);
          },
          clear: (e) => {
            console.log('clear', e);
          }
        }
      }
    },
    {
      field: 'title', width: 80, title: this.localePipe.transform('component.approvalPivot.title'),
      editor: { type: EditorTypes.TEXTBOX, options: {} }
    }, {
      field: 'description', width: 100, title: this.localePipe.transform('component.approvalPivot.description'), showTips: true,
      editor: { type: EditorTypes.TEXTBOX, options: {} }
    }
  ];

  modalConfig = {
    title: this.localePipe.transform('component.approvalPivot.approvalPivot'),
    width: 800,
    height: 480,
    showButtons: true
  };


  constructor(
    private designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  add() {
    const approvalPivot = new ApprovalPivot();
    this.config.approvalPivots = this.config.approvalPivots.concat([approvalPivot]);
  }

  delete() {
    const selectedRow = this.grid.selectedRow;
    if (!selectedRow) {
      this.message.info(this.localePipe.transform('component.approvalPivot.selectedRow'));
      return;
    }
    this.config.approvalPivots = this.config.approvalPivots.filter(a => a.id !== selectedRow.id);
  }

  clickOK() {
    if (!this.config.title && this.config.enable) {
      this.message.info(this.localePipe.transform('component.approvalPivot.configTitle'));
      return;
    }
    this.grid.endCellEdit();
    if (this.validator()) {
      const object = { value: this.config, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private validator() {
    return true;
  }


  editConditon(e: any) {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }

    this.expr.addExpressionText(e.instance.value);
    this.expr.setEditPattern(ExprEditMode.Conditional);
    this.expr.buildExpression().then((cond: string) => {
      e.formControl.setValue(cond);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
}

export class ApprovalPivotConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && data.enable) {
      return this.localePipe.transform('component.approvalPivot.set');
    } else {
      return this.localePipe.transform('component.approvalPivot.notSet');
    }
  }
}
